import React from "react";

const InfosysExperience = () => {
  return (
    <div className="row  pt-1 text-white">
      <div className="col-sm-12 col-md-12 mt-3">
        <h3>
          Senior Associate Consultant{" "}
          <span className="font-weight-bold newOrangeDarkStyle">@Infosys</span>
        </h3>
        <ul>
          <li>
            Worked on Banking Applications using agile methodology. It is a
            distributed and complex architecture system where code is
            distributed across more than 10 services.
          </li>
          <li>Primarily focus on Java.</li>
        </ul>
      </div>
    </div>
  );
};

export default InfosysExperience;
